import { useEffect, useState } from 'react'
import { useAuth0Token } from '../../infrastructure/auth0/authClient'

export function useUsername() {
  const [username, setUsername] = useState<string>()
  const { getRawAndClaims } = useAuth0Token()

  useEffect(() => {
    void (async () => {
      const { claims } = await getRawAndClaims()
      setUsername(
        claims?.['https://adshines.io/groups/user_metadata']?.username
      )
    })()
  }, [getRawAndClaims])

  return username
}
